import React from 'react';

import { NavigationContainer } from '@react-navigation/native';

import Routes from './rotas';

import {AppState} from 'react-native'

import ContextProvider from './util/provider'

import * as util from './util/util'

import {TIPO_AMB_DEV} from './util/constantes'
import {AMBIENTE, WS_URL_APP_DEV, WS_URL_APP_PROD} from './util/params'


export default function App() {
	
	React.useEffect(() => {
    
		const handleAppStateChange = (nextAppState) => {
     
			if (nextAppState === 'active') {
				util.print('Voltou ao primeiro plano');
			}
		};
	
		const subscription = AppState.addEventListener(
			'change',
			handleAppStateChange
		);
	
		return () => {
			subscription.remove();
		};
	}, []);


	const linking = {
		prefixes: [AMBIENTE== TIPO_AMB_DEV?WS_URL_APP_DEV:WS_URL_APP_PROD],
		config: {
		  screens: {
			login: 'login',
			principal: 'principal',
			novoUsuario: 'novoUsuario',
			detalheUsuario: 'detalheUsuario',
			novoItem: 'novoItem',
			meusItens: 'meusItens',
			detalheItem: 'detalheItem',
			anuncio: 'anuncio',
			meusPedidos: 'meusPedidos',
			detalhePedido: 'detalhePedido',
			novoPedido: 'novoPedido',
			minhasPropostas: 'minhasPropostas',
			novaProposta: 'novaProposta',
			detalheProposta: 'detalheProposta',
			categorias: 'categorias',
			subcategorias: 'subcategorias',
			buscarPedidos: 'buscarPedidos',
			buscarItens: 'buscarItens',
			loja: 'loja',
			meusEnderecos: 'meusEnderecos',
			financeiro: 'financeiro',
			propostasMeuPedido: 'propostasMeuPedido',
			chat: 'chat',
			novaDenuncia: 'novaDenuncia',
			denuncias: 'denuncias',
			lojaExterno: 'lojaExterno/:codigo'
		  },
		},
	};

	return (
		<ContextProvider>
			<NavigationContainer linking={linking}>
				<Routes/>
			</NavigationContainer>
		</ContextProvider>
	)
}
